import React, {useEffect, useState, useRef} from "react";
import axios from "axios";
import {Button} from "primereact/button";
import {base, expance, unit, budget_by_project, expance_type} from "../../../../api";
import {Dialog} from "primereact/dialog";
import {Toast} from "primereact/toast";
import ExpancesByRow from "./components/ExpancesByRow";
import CurrencyValue_data from "../../widgets/CurrencyValue_data";
import {Calendar} from "primereact/calendar";

export default function ExpancesProjectsMounthly(props) {
	const projectCurrencyValue = parseFloat(props?.project?.currency_value).toFixed(2);
	const toast = useRef(null);
	const [isEditing, setIsEditing] = useState(true);
	const [dialogVisibility, setDialogVisibility] = useState(false);
	const [optionExpances, setOptionExpances] = useState([]);
	const [optionExpanceType, setOptionExpanceType] = useState([]);
	const [optionUnit, setOptionUnit] = useState([]);
	const [budgetByProject, setBudgetByProject] = useState([]);
	const [filterDialog, setFilterDialog] = useState(false);
	const [projectID, setProjectID] = useState();

	const dateStringToObject = dateStr => (dateStr ? new Date(dateStr) : null);
	const dateObjectToString = dateObj =>
		dateObj
			? `${dateObj.getFullYear()}-${String(dateObj.getMonth() + 1).padStart(2, "0")}-${String(
					dateObj.getDate(),
			  ).padStart(2, "0")}`
			: "";

	const minimumDate = dateStringToObject(props?.project?.start_date);
	const maximumDate = dateStringToObject(props?.project?.end_date);

	const [selectedDayRange, setSelectedDayRange] = useState({
		from: minimumDate,
		to: maximumDate,
	});

	useEffect(() => {
		setSelectedDayRange({
			from: dateStringToObject(props?.project?.start_date),
			to: dateStringToObject(props?.project?.end_date),
		});
	}, [props?.project?.start_date, props?.project?.end_date]);

	useEffect(() => {
		if (props.projectID) {
			setProjectID(props.projectID);
		}
	}, [props.projectID]);

	useEffect(() => {
		loadContent();
	}, [props?.contentLoadTrigger]);

	const onFilter = () => {
		loadContent(
			`?from_date=${dateObjectToString(selectedDayRange.from)}&to_date=${dateObjectToString(
				selectedDayRange.to,
			)}`,
		);
		setFilterDialog(false);
	};

	const loadContent = async (params = null) => {
		try {
			const res = await axios.get(`${base}${budget_by_project}${props?.projectID}/${params || ""}`);
			setBudgetByProject(res.data.filter(budget => budget.count > 0));
		} catch (error) {
			if (error.response?.status === 404) {
				setBudgetByProject([]);
			} else {
				console.error("Error loading budget data:", error);
			}
		}

		try {
			const [expanceRes, unitRes, expanceTypeRes] = await Promise.all([
				axios.get(base + expance),
				axios.get(base + unit),
				axios.get(base + expance_type),
			]);
			setOptionExpances(expanceRes.data);
			setOptionUnit(unitRes.data);
			setOptionExpanceType(expanceTypeRes.data);
		} catch (error) {
			console.error("Error loading options:", error);
		}
	};

	const headerElement = (
		<div className="d-grid align-items-center">
			<span className="text-primary">{props?.project?.number}</span>
			<span className="small fw-normal">{props?.project?.name}</span>
			<span className="small fw-normal text-truncate">{props?.project?.full_name_am}</span>
		</div>
	);

	return (
		<>
			<div className="w-100 card p-3 rounded-4 shadow-lg mt-3">
				<div className="text-start my-3 fs-4 text-uppercase fw-bold px-3 border-bottom pb-3 d-flex align-items-center">
					<i className="pi pi-info-circle me-2 fs-4 fw-bold"></i>
					Ծախս
				</div>

				<div className="d-flex justify-content-end px-3 mb-3">
					<CurrencyValue_data data={projectCurrencyValue} />
					<div className="col-lg-4 col-12 text-end">
						<Button
							label="Filter budget"
							rounded
							severity="primary"
							icon="pi pi-filter"
							onClick={() => setFilterDialog(true)}
						/>
					</div>
				</div>

				<Dialog
					header={null}
					className="col-lg-6 col-md-5 col-6 mx-auto"
					visible={filterDialog}
					onHide={() => setFilterDialog(false)}>
					<div className="row">
						<Calendar
							value={[selectedDayRange.from, selectedDayRange.to]}
							onChange={e => setSelectedDayRange({from: e.value[0], to: e.value[1]})}
							selectionMode="range"
							readOnlyInput
							inline
							minDate={minimumDate}
							maxDate={maximumDate}
							numberOfMonths={2}
						/>

						<div className="col-12 mt-5 mb-3 text-center">
							<Button label={"Filter"} rounded onClick={onFilter} />
						</div>
					</div>
				</Dialog>

				{Array.isArray(budgetByProject) && budgetByProject.length > 0 ? (
					<div className="col-12 p-0">
						<ExpancesByRow
							data={projectID}
							projectCurrencyValue={projectCurrencyValue}
							currency_value={props?.currency_value}
						/>
					</div>
				) : (
					<div className="col-12">
						<div className="card w-100 border-0 text-center">Դեռ նշումներ չկան բյուջեի դաշտում</div>
					</div>
				)}

				<Toast ref={toast} />
			</div>
		</>
	);
}
